import $ from 'jquery'
import { Option } from '../components/types'

export const isModalOpened = (modalId: string) => $(`#${modalId}`).css('display') === 'block'

export const option = (value: string, label: string): Option => ({ value, label })

export const liveUrl = (imageUrl: string) => `${imageUrl}?t=${new Date().getTime()}`
